import React from 'react';

/**
 * Skeleton loader component for the task table
 * Provides visual feedback while project/tasks are loading
 */
const TaskTableSkeleton = ({ rowCount = 5 }) => {
  return (
    <div className="task-table-skeleton">
      {/* Header Skeleton */}
      <div className="skeleton-header">
        <div className="skeleton-title-section">
          <div className="skeleton-text skeleton-title-long" />
        </div>
        <div className="skeleton-actions">
          <div className="skeleton-button" />
        </div>
      </div>

      {/* Filter Tabs Skeleton */}
      <div className="skeleton-filter-row">
        <div className="skeleton-tab" />
        <div className="skeleton-tab" />
        <div className="skeleton-tab" />
      </div>

      {/* View Controls Skeleton */}
      <div className="skeleton-controls">
        <div className="skeleton-view-tabs">
          <div className="skeleton-view-tab" />
          <div className="skeleton-view-tab" />
          <div className="skeleton-view-tab" />
        </div>
        <div className="skeleton-create-btn" />
      </div>

      {/* Date Filters Skeleton */}
      <div className="skeleton-date-filters">
        <div className="skeleton-date-group">
          <div className="skeleton-date-input" />
          <div className="skeleton-date-input" />
          <div className="skeleton-clear-btn" />
        </div>
        <div className="skeleton-search-group">
          <div className="skeleton-entries-select" />
          <div className="skeleton-search-input" />
        </div>
      </div>

      {/* Table Skeleton */}
      <div className="skeleton-table-wrapper">
        <div className="skeleton-table">
          {/* Table Header */}
          <div className="skeleton-table-header">
            <div className="skeleton-th skeleton-th-name" />
            <div className="skeleton-th skeleton-th-date" />
            <div className="skeleton-th skeleton-th-date" />
            <div className="skeleton-th skeleton-th-days" />
            <div className="skeleton-th skeleton-th-days" />
            <div className="skeleton-th skeleton-th-status" />
            <div className="skeleton-th skeleton-th-priority" />
            <div className="skeleton-th skeleton-th-action" />
          </div>

          {/* Table Rows */}
          {Array.from({ length: rowCount }).map((_, index) => (
            <div
              key={index}
              className={`skeleton-table-row ${index % 2 === 1 ? 'odd' : ''}`}
            >
              <div className="skeleton-td skeleton-td-name" />
              <div className="skeleton-td skeleton-td-date" />
              <div className="skeleton-td skeleton-td-date" />
              <div className="skeleton-td skeleton-td-days" />
              <div className="skeleton-td skeleton-td-days" />
              <div className="skeleton-td skeleton-td-status" />
              <div className="skeleton-td skeleton-td-priority" />
              <div className="skeleton-td skeleton-td-action" />
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Skeleton */}
      <div className="skeleton-pagination">
        <div className="skeleton-page-btn" />
        <div className="skeleton-page-numbers">
          <div className="skeleton-page-num" />
          <div className="skeleton-page-num" />
          <div className="skeleton-page-num" />
        </div>
        <div className="skeleton-page-btn" />
      </div>
    </div>
  );
};

export default TaskTableSkeleton;
